export default "__VITE_ASSET__83edd8cb__"